/* eslint-disable camelcase */
import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const TaskUserRemovedAuditItemDetails = ({ audit }) => {
  const {
    auditedChanges,
    task,
    taskAssignee,
    taskMember,
  } = audit

  const { relationship_type } = auditedChanges

  if (relationship_type === "assignee") {
    return (
      <div>
        <span>
          <AuditedUser audit={audit} /> unassigned and removed&nbsp;
          <span className="font-semibold">{taskAssignee.fullName}</span> from
          the task titled <span className="font-semibold">{task.title}</span>.
        </span>
      </div>
    )
  }

  if (relationship_type === "member") {
    return (
      <div>
        <span>
          <AuditedUser audit={audit} /> removed&nbsp;
          <span className="font-semibold">{taskMember.fullName}</span> from
          the task titled <span className="font-semibold">{task.title}</span>.
        </span>
      </div>
    )
  }

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> removed a user from
        the task titled <span className="font-semibold">{task.title}</span>.
      </span>
    </div>
  )
}

TaskUserRemovedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default TaskUserRemovedAuditItemDetails
